import { RequestField, RequestType } from '@const/consts';
import { IChangeFull } from './types';

export const steps = 5;

export enum stepName {
  START = 1,
  ADDRESS = 2,
  OBJECTS = 3,
  SERVICES = 4,
  VIEW = 5,
}

export enum RequestDraftMode {
  EMPTY_BOX_DELIVERY = 'empty_box_delivery',
  BOX_PICKUP = 'box_pickup',
  CENTRAL_STORE_REQUISITION = 'central_store_requisition',
}

export const EMPTY_BOX_DELIVERY_REQUEST_TYPE_NAME = 'Delivery - Empty box';

export interface IRequestDraftModeConfig {
  allowedCategories?: string[]
  excludedRequestTypeNames?: string[]
  fixedRequestTypeName?: string
  steps: stepName[]
  title: string
}

export const requestDraftModeConfigs: Record<RequestDraftMode, IRequestDraftModeConfig> = {
  [RequestDraftMode.EMPTY_BOX_DELIVERY]: {
    fixedRequestTypeName: EMPTY_BOX_DELIVERY_REQUEST_TYPE_NAME,
    steps: [stepName.START, stepName.ADDRESS, stepName.SERVICES, stepName.VIEW],
    title: 'requests:request_empty_box',
  },
  [RequestDraftMode.BOX_PICKUP]: {
    allowedCategories: [RequestType.PICKUP],
    steps: [stepName.START, stepName.ADDRESS, stepName.OBJECTS, stepName.VIEW],
    title: 'requests:request_box_pickup',
  },
  [RequestDraftMode.CENTRAL_STORE_REQUISITION]: {
    allowedCategories: [RequestType.DELIVERY],
    excludedRequestTypeNames: [EMPTY_BOX_DELIVERY_REQUEST_TYPE_NAME],
    steps: [stepName.START, stepName.ADDRESS, stepName.OBJECTS, stepName.VIEW],
    title: 'requests:central_store_requisition',
  },
};

export const initialValuesOnStep = {
  [stepName.START]: {
    account: '',
    request_type: null,
    sub_account: '',
    sub_account_count: 0,
    terminal: '',
    is_digital: false,
  },
  [stepName.ADDRESS]: {
    contact_email: '',
    contact_phone: '',
    initiator: '',
    address: '',
    city: '',
    contact_name: '',
    notes: '',
    planned_completion_date: null,
    pass_is_needed: false,
    process_is_needed: false,
  },
};

export const initialValues = {
  account: '',
  address: '',
  city: '',
  contact_email: '',
  contact_name: '',
  contact_phone: '',
  initiator: '',
  is_digital: false,
  last_step: stepName.START,
  notes: '',
  planned_completion_date: null,
  pass_is_needed: false,
  process_is_needed: false,
  request_type: null,
  sub_account: '',
  sub_account_count: 0,
  terminal: '',
};

export const createValues = {
  account: '',
  planned_completion_date: null,
  request_type: '',
  sub_account: '',
  terminal: '',
};

export const fieldsStep1 = [RequestField.REQUEST_TYPE, RequestField.TERMINAL, RequestField.ACCOUNT, RequestField.SUB_ACCOUNT];

export enum RequestInfo {
  REQUEST_TYPE = 'request_type',
  TERMINAL = 'terminal',
  ACCOUNT = 'account',
  SUB_ACCOUNT = 'sub_account',
  INITIATOR = 'initiator',
  ADDRESS = 'address',
  CONTACT = 'contact',
}

export const infoStep1 = [RequestInfo.REQUEST_TYPE, RequestInfo.TERMINAL, RequestInfo.ACCOUNT, RequestInfo.SUB_ACCOUNT];

export const InitChangeFull: IChangeFull = {
  needChange: false,
  withReset: false,
};
